const IS_MENU_COLLAPSED = "IS_MENU_COLLAPSED";

const setLastMenuCollapsed = (isMenuCollapsed) => {
  return localStorage.setItem(IS_MENU_COLLAPSED, isMenuCollapsed);
};
const getLastMenuCollapsed = () => {
  return localStorage.getItem(IS_MENU_COLLAPSED) === "true" || false;
};

const getDefaultState = () => {
  return {
    isCollapsed: false, // drawer para mobile
    isMenuCollapsed: getLastMenuCollapsed() // menu lateral
  };
};

export default {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    TOGGLE_COLLAPSED: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
    SET_COLLAPSED: (state) => {
      state.isCollapsed = false;
    },
    TOGGLE_MENU_COLLAPSED: (state) => {
      setLastMenuCollapsed(!state.isMenuCollapsed);
      state.isMenuCollapsed = !state.isMenuCollapsed;
    }
  },

  actions: {
    toggleCollapsed: ({ commit }) => {
      commit("TOGGLE_COLLAPSED");
    },
    setCollapsed: ({ commit }) => {
      commit("SET_COLLAPSED");
    },
    toggleMenuCollapsed: ({ commit }) => {
      commit("TOGGLE_MENU_COLLAPSED");
    }
  }
};
